import { render, staticRenderFns } from "./AuthorProfilePage.vue?vue&type=template&id=efa25130&scoped=true"
import script from "./AuthorProfilePage.vue?vue&type=script&lang=js"
export * from "./AuthorProfilePage.vue?vue&type=script&lang=js"
import style0 from "./AuthorProfilePage.vue?vue&type=style&index=0&id=efa25130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa25130",
  null
  
)

export default component.exports